import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AutoSuggestionSelectComponent from '../../common/auto-suggestion-select/Select';
import { getNetworksList } from '../../../../redux/admin/api-calls/priceCompare';

export const ChooseNetwork = ({
  onChange,
  customOptions,
  value,
  inputClassName,
  id = '',
  labelText = '',
}) => {
  const dispatch = useDispatch();

  const {
    networksList,
    searchProviderParams: { Network },
    isNetworksListFetched,
  } = useSelector(({ priceCompareAdmin }) => priceCompareAdmin);

  useEffect(() => {
    if (!isNetworksListFetched) {
      //dispatch(getNetworksList());
    }
  }, []);

  return (
    <AutoSuggestionSelectComponent
      options={
        customOptions !== null || customOptions !== undefined
          ? customOptions
          : networksList
      }
      onChange={onChange}
      components={{ IndicatorSeparator: () => null }}
      value={value}
      defaultValue={networksList?.length > 0 ? networksList[0] : []}
      inputClassName={inputClassName}
      id={id}
      labelText={labelText}
    />
  );
};
